import React, { Component } from "react";
import withRouter from "../../../Utils/withRouter";
import EducationalDetails from "../EducationalDetails";
import UpdateEmployeeNavigationSideBar from "./UpdateEmployeeNavigationSideBar";
import { ConfigContext } from "../../../Context/ConfigContext";
import axios from "axios";
import { NavLink } from "react-router-dom";
import TooltipComponent from "../../../Components/TooltipComponent";
import { decodeData, decodeUrl, encodeData } from "../../../Constants/constants";

class ManageEducationDetails extends Component {

  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      employee_code: null,
      employee_name: "",
      encodedData: '',
      decodedDataId: '',
      decodedData: [],
    };
  }

  componentDidMount(){
    if(this.props.params.employee_id){
      this.GetInfo();
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.permissions !== this.context.permissions) {
      // console.log("Permissions Updated:", this.context.permissions);
        const { permissions } = this.context;
        if (permissions.length > 0) {
          const queryParams = new URLSearchParams(window.location.search);
          const encodedData = queryParams.get("abs");
          const decodedDataId = decodeUrl(encodedData);
          console.log("decodedDataId",decodedDataId);
          const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
          console.log("decodedData",decodedData);
          if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
            this.setState({encodedData,decodedDataId, decodedData });
        }
        } else {
          console.warn("Permissions not yet available. Retrying...");
        }
    }
  }

  GetInfo = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Employees/GetEmployeeInfo?employee_id=${this.props.params.employee_id}`, { headers }).then((response) => {
      const { data, success } = response.data;
      if (success === true) {
        // console.log("data[0].employee_state",data[0].employee_state);
        this.setState(
          {
            employee_code: data[0].employee_code,
            employee_name: data[0].employee_name,
          }
        )
      }
    });
  }

  render() {
    return (
      <div className="main-content">
        <div style={{ paddingBottom:'0.7rem' }}  className="page-content">
          <div className="container-fluid">
            <div style={{ maxHeight:"80vh" }} className="row overflow-y-scroll overflow-x-hidden">
              <div className="col-xl-12">
                <div className="card">
                  <div style={{ padding:'0.7rem' }} className=" card-header sticky-top z-1">
                    <div className=" align-items-center justify-content-between d-flex">
                      <h4 className="card-title mb-0">Update Employee</h4>
                      <div className=" align-items-center gap-2 d-flex">
                      <h6 className="mb-0">{this.state.employee_code}(<span style={{ color:"#808080" }}>{this.state.employee_name}</span>)</h6>
                      {/* <h4 className="mb-0"></h4> */}
                      <TooltipComponent name="Back" position="bottom">
                      <NavLink 
                        className="btn btn-success btn-sm" to={`/CandidateDetailsList?abs=${encodeData(this.state.decodedDataId)}`}
                        accordion >
                        <i className="bx ri-arrow-left-circle-line label-icon align-middle fs-4 " />
                      </NavLink>
                      </TooltipComponent>
                      </div>
                    </div>
                  </div>
                  {/* end card header */}
                  <div className="card-body form-steps">
                    <div className="vertical-navs-step">
                      <div className="row gy-5">
                        <UpdateEmployeeNavigationSideBar employee_id = {this.props.params.employee_id} />
                        {/* end col*/} 
                        <div className="col-lg-9">
                          <div className="px-lg-4">
                            <div className="tab-content">
                              <div
                                className="tab-pane fade show active"
                                id="v-pills-bill-info"
                                role="tabpanel"
                                aria-labelledby="v-pills-bill-info-tab"
                              >
                                <EducationalDetails />
                              </div>
                             
                              {/* end tab pane */}
                            </div>
                            {/* end tab content */}
                          </div>
                        </div>
                        {/* end col */}
                      </div>
                      {/* end row */}
                    </div>
                  </div>
                </div>
                {/* end */}
              </div>
              {/* end col */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ManageEducationDetails);
